<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <div class="m-b-24">
        <el-button type="primary" size="small" @click="outExportKeywordList" v-if="this.$hasPerm('B001')">导出关键词</el-button>
        <el-button type="primary" size="small" @click="inputExportKeywordList" v-if="this.$hasPerm('B001')">导入关键词</el-button>
      </div>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="关键词:">
              <el-input v-model="keywordReq.keyword" placeholder="请输入关键词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text left">
              <el-button type="primary" size="mini" @click="search">搜索</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
     <div class="padding15 bg-content">
       <p class="text right">
        <el-button type="primary" @click="openCreateKeywords" plain>添加关键词</el-button>
      </p>
      <br/>
       <el-table
        size="small"
        v-loading="loading"
        :data="list"
        border
        :row-style="{cursor: 'pointer'}"
        highlight-current-row>
        <el-table-column
          property="id"
          label="ID"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="keyword"
          label="关键词"
          header-align="center"
          align="center"
          width="230px">
        </el-table-column>
        <el-table-column
          property="createUserName"
          label="创建人"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          property="weight"
          label="权重0"
          header-align="center"
          align="center"
          sortable>
        </el-table-column>
        <el-table-column
          property="weight1"
          label="权重1"
          header-align="center"
          align="center"
          sortable>
        </el-table-column>
        <el-table-column
          property="weight2"
          label="权重2"
          header-align="center"
          align="center"
          sortable>
        </el-table-column>
        <el-table-column
          property="createTime"
          label="创建时间"
          key="createTime"
          header-align="center"
          width="150px"
          align="center">
        </el-table-column>
        <el-table-column
          property="id"
          label="操作"
          header-align="center"
          align="center">
           <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editKeyword(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="confirmDelete(scope.row)"></el-button>
          </template>
        </el-table-column>
       </el-table>
       <div class="text center margin15-tb">
          <el-pagination
            background
            layout="prev, pager, next, sizes, total"
            :page-sizes="[50, 100, 200]"
            :total="keywordReq.totalRecords"
            :page-size="keywordReq.limit"
            :current-page="keywordReq.page"
            @current-change="currentChange"
            @size-change="sizeChange">
          </el-pagination>
        </div>
    </div>
    <div class="dialog">
      <el-dialog
        :title=this.title
        :visible.sync="openCreateKeyword"
        width="50%"
        center>
        <el-form label-width="160px">
          <el-input type="textarea" :rows="6" v-model="keywordText" style="width: 100%;" placeholder="请输入关键词"></el-input>
          <span style="color: red" v-show="showDialog">* 可换行添加多个</span>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="openCreateKeyword = false" size="small">取消</el-button>
          <el-button type="primary" @click="editKeywordSave" size="small">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog
        title="导入关键词"
        :visible.sync="importKeyword"
        width="30%"
        center>
        <el-form label-width="180px">
          <el-form-item label="文件上传">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="1"
              :auto-upload="false"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :on-change="fileChanged">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">请上传模版的Excel</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" size="small"><a href="/static/template/importKeywords.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>
          <el-button type="primary" @click="uploadData" size="small">提交数据</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      keywordReq: {
        keyword: '',
        totalRecords: 0,
        limit: 50,
        page: 1
      },
      list: [],
      keywordText: '',
      openCreateKeyword: false,
      title: '',
      showDialog: false,
      keywordId: '',
      fileList: [],
      importKeyword: false
    };
  },
  // 进入页面调用此方法
  mounted() {
    this.getKeywordList();
  },
  methods: {
    handleRemove(file, fileList) {
      console.warn(file, fileList);
    },
    handlePreview(file) {
      console.warn(file);
    },
    handleExceed(files, fileList) {
      console.warn(fileList);
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length} 个文件`);
    },
    beforeRemove() {
      this.fileList = [];
    },
    fileChanged(files, fileList) {
      if (files.size > (5 * 1024 * 1024)) {
        this.$message.warning('文件大小超出5M,请重新选择！');
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    currentChange(page) {
      console.warn('选页');
      this.keywordReq.page = page;
      this.getKeywordList();
    },
    // 显示条数
    sizeChange(num) {
      console.warn('每页条数');
      this.keywordReq.limit = num;
      this.getKeywordList();
    },
    // 搜索按钮
    search() {
      this.keywordReq.page = 1;
      this.getKeywordList();
    },
    // 重置
    reset() {
      this.keywordReq.keyword = '';
    },
    // 搜索
    getKeywordList() {
      const search = this.keywordReq;
      this.$ajax({
        url: '/keyword/getKeywordList',
        data: search
      }).then((res) => {
        console.warn(res);
        this.list = res.data.list;
        this.keywordReq.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    openCreateKeywords() {
      this.title = '添加关键词';
      this.showDialog = true;
      this.keywordText = '';
      this.openCreateKeyword = true;
    },
    // 修改
    editKeyword(full) {
      console.warn(full);
      this.title = '修改关键词';
      this.showDialog = false;
      this.keywordText = full.keyword;
      this.keywordId = full.id;
      this.openCreateKeyword = true;
    },
    // 删除
    confirmDelete(full) {
      console.warn(full);
      this.$confirm('是否确定删除此关键词？?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/keyword/deleteKeywordById',
          params: { id: full.id }
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.getKeywordList();
        }).catch((error) => {
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    outExportKeywordList() {
      console.warn('导出关键词');
      const countAll = this.keywordReq.totalRecords;
      if (countAll === 0) {
        this.$message({
          type: 'error',
          message: '没有关键词可以导出，请重新选择！'
        });
        return;
      }
      const search = {};
      if (this.keywordReq.keyword) {
        search.keyword = this.keywordReq.keyword;
      }
      search.excelToken = localStorage.getItem('authorization');
      const fileUrl = '/webapi/v1/keyword/outExportKeywordList';
      const form = document.createElement('form');
      form.setAttribute('action', fileUrl);
      form.setAttribute('method', 'get');
      form.setAttribute('id', 'download');
      document.body.appendChild(form);
      Object.keys(search).forEach((key) => {
        const input = document.createElement('input');
        input.setAttribute('name', key);
        input.setAttribute('value', search[key]);
        input.style.display = 'none';
        form.appendChild(input);
      });
      form.submit();
      setTimeout(() => {
        const parent = document.querySelector('#download');
        const childs = parent.childNodes;
        for (let i = childs.length - 1; i >= 0; i--) {
          parent.removeChild(childs[i]);
        }
        console.warn(parent);
        document.body.removeChild(form);
      }, 1000);
    },
    // 添加/修改关键词提交
    editKeywordSave() {
      if (this.showDialog) {
        console.warn('添加关键词');
        const search = {};
        search.keyword = this.keywordText;
        this.$ajax({
          prompt: true,
          url: '/keyword/insetKeywordBatch',
          data: search
        }).then(() => {
          this.openCreateKeyword = false;
          this.getKeywordList();
        });
      } else {
        console.warn('修改关键词');
        const search = {};
        search.keyword = this.keywordText;
        search.id = this.keywordId;
        this.$ajax({
          prompt: true,
          url: '/keyword/updateKeywordById',
          data: search
        }).then(() => {
          this.openCreateKeyword = false;
          this.getKeywordList();
        });
      }
    },
    inputExportKeywordList() {
      console.warn('导入关键词');
      this.importKeyword = true;
    },
    // 导入关键词
    uploadData() {
      if (this.fileList.length === 0) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      this.loading = true;
      this.$ajax({
        url: '/keyword/importKeywords',
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        this.loading = false;
        this.importKeyword = false;
        this.keywordReq.page = 1;
        this.getKeywordList();
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/page/main/algCorpus/robotKeyWord.vue